import { InjectionToken } from "@angular/core";

export const SHARED_XP = new InjectionToken("shared_state");

/**
 * This class is used to share state between weeklyquiz component and weeklyquiz-wrapper component.
 * This class is used for sharing total Experience Points earned by user by completing weekly quiz exercises.
 */
export class SharedExperiencePoint {
    constructor(public experiencePoint?: number, public isReset?: boolean) { }
}
